import { useEffect, useState } from 'react';
import useDebounce from './useDebounce';

const usePaginatedListPage = ({
  fetchItems,
  page: controlledPage,
  setPage: controlledSetPage,
  deps = [],
  debounceMs = 500,
  search: controlledSearch,
  setSearch: controlledSetSearch,
}) => {
  const [internalPage, setInternalPage] = useState(1);
  const [internalSearch, setInternalSearch] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const page = controlledPage ?? internalPage;
  const setPage = controlledSetPage ?? setInternalPage;
  const search = controlledSearch ?? internalSearch;
  const setSearch = controlledSetSearch ?? setInternalSearch;
  const debouncedSearch = useDebounce(search, debounceMs);

  useEffect(() => {
    const load = async () => {
      setIsLoading(true);
      await fetchItems(page, debouncedSearch, ...deps);
      setIsLoading(false);
    };
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchItems, page, debouncedSearch, ...deps]);

  return {
    page,
    setPage,
    search,
    setSearch,
    debouncedSearch,
    isLoading,
    setIsLoading,
  };
};

export default usePaginatedListPage;
